export enum IncotermsEnum {
    EXW = 'EXW',
    FCA = 'FCA',
    CFR = 'CFR',
    CIF = 'CIF',
    DAP = 'DAP',
    DDP = 'DDP'
}
